<template>
  <div>
    <div class="bill_loader page_loader" v-if="!loaded">
      <div>טוען את ההזמנה...</div>
      <img :src="loaderGif"/>
    </div>
    <section class="page_order_edit over--hide" v-if="loaded">
      <div class="container flex flex--reverse">
        <div class="page_edit_side">
          <div class="edit_explane_top center">
            <div class="f_raana relative">במצב 'עריכה' רשימת המוצרים תופיע בעגלה שלך
              <img :src="assets_url + '/layout/edit_arrowt.png'"></div>
          </div>
          <div class="bill relative" v-show="loaded">
            <div class="bill_pad">
              <div class="bill_head center over--hide">
                <span class="inline relative"><LOGO/></span>
              </div>
              <div id="scrollbar1" class="bill_scroll">
                <div class="scrollbar" v-if="false">
                  <div class="track">
                    <div class="thumb">
                      <div class="end"></div>
                    </div>
                  </div>
                </div>
                <div class="viewport scroll">
                  <div class="overview text">
                    <div class="order_item" v-for="item in order.items" :key="item.id">
                      <span class="order_item__q">{{ item.quantity }} {{ selectedText(item) }} </span>
                      <span class="order_item__name" v-html="item.name"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bill_bottom flex" v-if="order">
                <div class="col-50">
                  <div class="bill_type">הזמנה מס’</div>
                  <div class="bill_info">{{ order.meta['doc_number'][0] }}</div>
                </div>
                <div class="col-50">
                  <div class="bill_type">תאריך המשלוח</div>
                  <div class="bill_info">{{ date }}</div>
                </div>
                <div class="col-50">
                  <div class="bill_type">שעת המשלוח</div>
                  <div class="bill_info">{{ time }}</div>
                </div>
                <div class="col-50">
                  <div class="bill_type">כתובת המשלוח</div>
                  <div class="bill_info" v-html="street"></div>
                </div>
              </div>
              <div class="bill_barcode no_mobile"><img :src="assets_url + '/layout/bill_barcode.png'"></div>
            </div>

          </div>
          <div class="bill_loader" v-show="!loaded">
            <div>טוען את ההזמנה...</div>
            <img :src="loaderGif"/>
          </div>
        </div>
        <div class="page_edit_main is--fit flex flex--end m-100">
          <div class="page_edit_content relative">
            <div class="box_edit_img no_mobile"><img :src="assets_url + '/layout/box_edit.png'"></div>
            <h1 class="title tx--red">{{ page.title }}</h1>
            <div class="title subt">{{ page.acf.subtitle }}</div>
            <div class="title25 tx--green bold">{{ page.acf.text_title }}</div>
            <div class="text has--p" v-html="page.post_content">
            </div>

            <div class="perm-notice" v-if="order.meta.is_permanent_order_child">
              <p>
                חשוב לשים לב!<br/>
                השינוייים שביצעת יחולו רק על הזמנה זו (ולא על כל ההזמנות הקבועות שלך)
              </p>
            </div>

            <div class="edit_content_btns flex flex--center" v-if="order">
              <div class="bt_green">
                <a class="order-edit-btn" :class="{'active loading' : editButtonLoader}" href="javascript:void(0);" @click="editOrder">
                  <span>המשך לעריכה</span>
                  <img :src="loaderSVG"/>
                </a>
              </div>
              <div class="link">
                <router-link to="/">התחרטתי, המשיכו עם ההזמנה כרגיל</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


  </div>
</template>
<script>
import LOGO from "../assets/img/logo.svg";
import {mapActions, mapMutations, mapState} from "vuex";
import PerfectScrollbar from "perfect-scrollbar";

export default {
  components: {
    LOGO,
  },
  data() {
    return {
      assets_url: wpData.assets_url,
      loaderSVG: wpData.assets_url + "/svg/loader.svg",
      order: false,
      loaded: false,
      wpData: wpData,
      loaderGif: wpData.assets_url + "/layout/ajax-loader.gif",
      editButtonLoader: false
    };
  },
  watch: {
    loaded(value) {
      if (value) {
        const items_scroll = new PerfectScrollbar(".scroll", {
          wheelSpeed: 0.5,
          maxScrollbarLength: 60
        });
      }

    }
  },
  computed: {
    page: function () {
      if (typeof wpData.pageData != "object") {
        return JSON.parse(wpData.pageData);
      }
      return wpData.pageData;
    },
    date() {
      if (this.order) {

        return this.order.meta['jckwds_date'][0];
      }
      return '';
    },
    time() {
      if (this.order) {

        return this.order.meta['jckwds_timeslot'][0];
      }
      return '';
    },

    street() {
      if (this.order && this.loaded) {
        let html = "";
        if (this.order.meta['shipping_street']) {
          html = this.order.meta['shipping_street'][0]
              + (typeof this.order.meta['shipping_house'] !== 'undefined' ? " " + this.order.meta['shipping_house'][0] : "") + ", "
              + this.order.meta["_shipping_city"][0] + " ";
        } else {
          html = this.order.meta['billing_street'][0]
              + (typeof this.order.meta['billing_house'] !== 'undefined' ? " " + this.order.meta['billing_house'][0] : "") + ", "
              + this.order.meta["_billing_city"][0] + " ";
        }
        return html;
      }
      return '';
    }

  },
  mounted() {
    this.$nextTick(() => {
      this.$ajax.get(ajaxUrl + "?action=getOrderById&order_id=" + this.$route.query.orderID)
          .then(response => {
            this.order = response.data;
            this.loaded = true;
          })
          .catch(e => console.log(e));
    })
  },
  methods: {
    ...mapActions(["getProductById", "updateCart", "clarCart"]),
    ...mapMutations(["setOrderEdit", "setOrderMeta", "setCoupon", "useCashbackPoints"]),
    unitPriceText(item) {
      if (item.type === "unit") {
        if (item.case) {
          return "מארז";
        }
        return "יח׳";
      } else if (item.type === "kg") {
        return "ק״ג";
      } else if (item.type === "both") {
        return "ק״ג";
      } else if (item.type === "unitaskg") {
        return "ק״ג";
      }
      return false;
    },
    selectedText: (product) => {
      switch (product.selected) {
        case "full":
          return "שלם";
        case "spread":
          return "פרוס";
        case "unit":
          if (product.case) {
            return "מארז";
          }
          return "יח׳";
        case "kg":
          return "ק״ג";
      }
    },
    validateCoupon(coupon) {
      let data = new FormData();
      data.append("coupon", coupon);
      this.$ajax.post("?checkCoupon", data).then(res => {
        if (res.data.success) {
          //check if giftcard first
          if (res.data.data.hasOwnProperty("card_id")) {
            const giftCard = {
              id: res.data.data.card_id,
              balance: res.data.data.balance
            }
            this.$store.commit("setGiftcard", giftCard);
          } else {
            // if not giftcard then its coupon
            this.$store.commit("setCoupon", res.data.data);
          }
        }
      }).catch(e => () => {
        this.couponIsLoading = false;
      });
    },
    editOrder() {

      this.editButtonLoader = true;

      this.clarCart();
      this.$ajax({
        method: "POST",
        url: homeUrl + "?checkOrderStatus",
        params: {
          docNumber: this.order.meta.doc_number[0],
          orderId: this.order.orderID
        }
      }).then(res => {
        if (res.data.status == 200 && res.data.order_status) {

          this.order.items.map(product => {
            this.updateCart([product, true]);
          });
          this.$root.$emit("orderCopy");

          if (this.$store.state.outOfStockCart.length > 0) {
            this.$modal.show("not-exist");
          }
          this.setOrderEdit(this.order.meta.doc_number[0]);
          this.setOrderMeta(this.order);

          let coupon = (this.order.meta.coupon_code === undefined) ? "" : this.order.meta.coupon_code[0];
          if (coupon) {
            this.validateCoupon(coupon);
          }

          let giftcard = (this.order.meta.gift_card_id === undefined) ? "" : this.order.meta.gift_card_id[0];
          if (giftcard) {
            this.validateCoupon(giftcard);
          }

          let cashback = (this.order.meta.cashback_points_used === undefined) ? "" : this.order.meta.cashback_points_used[0];
          if (cashback) {
            this.$store.commit('useCashbackPoints', cashback);
          }

          this.$router.push({path: '/'});
          this.editButtonLoader = false;
          setTimeout(() => {
            $(".cart").fadeIn(100, function () {
              $("body").addClass("noscroll");
              $(".cart_in").animate(
                  {
                    left: 0
                  },
                  600
              );
            });
          }, 1000);
        }
      }).catch(e => console.log(e));
    }
  }
};
</script>
<style scoped>
.order_item__name br {
  display: none;
}
.bill_loader img {
  max-width: 30px;
}
.bill_loader {
  text-align: center;
}
@media screen and (max-width: 800px) {
  .bill_scroll {
    display: none;
  }
}
</style>

<style lang="sass" scoped>
.order-edit-btn
  position: relative

  img
    display: none
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

.order-edit-btn.loading
  img
    display: block

  span
    opacity: 0

.perm-notice
  margin: 2rem 0

  p
    color: #ed0016
    font-weight: bold

.page_loader
  min-height: 100vh
  display: flex
  align-items: center
  justify-content: center
</style>
